"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var generateRouteTypes_exports = {};
__export(generateRouteTypes_exports, {
  generateRouteTypes: () => generateRouteTypes
});
module.exports = __toCommonJS(generateRouteTypes_exports);
var import_promises = require("fs/promises");
var import_path = require("path");
var import_fs_extra = __toESM(require("fs-extra"), 1);
var import_matchers = require("../router/matchers");
var import_useViteRoutes = require("../router/useViteRoutes");
var import_routeIndex = require("../utils/routeIndex");
var import_getTypedRoutesDeclarationFile = require("./getTypedRoutesDeclarationFile");
var import_injectRouteHelpers = require("./injectRouteHelpers");
async function generateRouteTypes(outFile, routerRoot, ignoredRouteFiles, typedRoutesMode, routePathsIn) {
  var routePaths = routePathsIn !== null && routePathsIn !== void 0 ? routePathsIn : (0, import_routeIndex.getRoutePaths)(routerRoot, ignoredRouteFiles);
  var routes = routePaths.reduce(function(acc, cur) {
    var vitePath = `/${routerRoot}/${cur.replace(/^\.\//, "")}`;
    acc[vitePath] = {};
    return acc;
  }, {});
  var context = (0, import_useViteRoutes.globbedRoutesToRouteContext)(routes, routerRoot);
  var declarations = (0, import_getTypedRoutesDeclarationFile.getTypedRoutesDeclarationFile)(context);
  var outDir = (0, import_path.dirname)(outFile);
  var currentDeclarations;
  try {
    currentDeclarations = await (0, import_promises.readFile)(outFile, "utf8");
  } catch (error) {
    if (error.code !== "ENOENT") {
      throw error;
    }
  }
  if (currentDeclarations !== declarations) {
    await import_fs_extra.default.ensureDir(outDir);
    await (0, import_promises.writeFile)(outFile, declarations);
  }
  if (typedRoutesMode) {
    var mode = typedRoutesMode === "type" ? "type" : "runtime";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = routePaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var routePath = _step.value;
        if (routePath.includes("_layout") || routePath.includes("+api") || routePath.startsWith("_") || routePath.endsWith(".d.ts")) {
          continue;
        }
        var fullPath = (0, import_path.join)(process.cwd(), routerRoot, routePath);
        var routeName = routePath.replace(/^\.\//, "").replace(/\+[^/]*$/, "").replace(/\/index$/, "").replace(/index$/, "");
        var cleanRouteName = (0, import_matchers.removeSupportedExtensions)(routeName).replace(/\/?index$/, "");
        if (!cleanRouteName.startsWith("/")) {
          cleanRouteName = "/" + cleanRouteName;
        }
        if (!cleanRouteName.includes("[")) {
          continue;
        }
        await (0, import_injectRouteHelpers.injectRouteHelpers)(fullPath, cleanRouteName, mode);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}
//# sourceMappingURL=generateRouteTypes.js.map
